import { useGasv3Listener } from '@atlassian/post-office-context/analytics-listener/hook';
import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { useEffect } from 'react';

export const useClickedRovoNudgeCta = ({ nudgeId }: { nudgeId: string }): void => {
	const { onCtaActioned } = usePostOfficeUserInteractions();

	const clicked = useGasv3Listener({
		action: 'clicked',
		actionSubject: 'rovoButton',
		actionSubjectId: 'aiRovoProactiveNudge',
		attributes: {
			recommendationFeatureId: nudgeId,
		},
	});

	useEffect(() => {
		if (clicked) {
			onCtaActioned({ interactionIdentifier: 'cta' });
		}
	}, [clicked, onCtaActioned]);
};
